export default __webpack_public_path__ + "static/media/gtd9.308f144d.jpg";